

    <div class="wrapper shadowed">
        <h5>Intervenants SAV</h5>
        <p>Ajout</p>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <mat-form-field>
                <mat-label>Nom</mat-label>
                <input matInput formControlName="nom">
            </mat-form-field>

            <button type="submit" class="btn btn-primary submit"
                [disabled]="!form.valid">Enregistrer</button>

        </form>

        <br>

        <button class="btn btn-primary" (click)="onClickVoirListe()">{{ message }}</button>

        <div class="displayList" *ngIf=displayList>

            <mat-table [dataSource]="intervenantsSavList">
                <ng-container matColumnDef="nom">
                    <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
                    <mat-cell *matCellDef="let inter"> {{inter.intervenant_name}} </mat-cell>
                </ng-container>
        
                <ng-container matColumnDef="edit">
                    <mat-header-cell *matHeaderCellDef> Editer </mat-header-cell>
                    <mat-cell  *matCellDef="let inter"> <mat-icon (click)="onEdit(inter)">edit</mat-icon> </mat-cell>
                </ng-container>
                <ng-container matColumnDef="delete">
                    <mat-header-cell *matHeaderCellDef> Supprimer </mat-header-cell>
                    <mat-cell *matCellDef="let inter">
                        <mat-icon (click)="onDelete(inter.intervenant_id, inter)">delete</mat-icon>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumn"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['nom', 'edit', 'delete'] ;"></mat-row>
            </mat-table>

        </div>
    
    </div>


